import React from 'react'

import { Button } from '@gousto-internal/citrus-react'
import classnames from 'classnames'
import config from 'config'
import PropTypes from 'prop-types'

import { AppStoreLinks } from 'components/AppStoreLinks'

import { TickList } from './TickList'

import css from './AppPromo.css'

const benefits = [
  'Be the first to know when the menu is out',
  'Track your orders on the go',
  'Store all your recipes in your personal cookbook',
]

const propTypes = {
  device: PropTypes.string,
  trackWelcomeAppPromoClick: PropTypes.func,
}

const defaultProps = {
  device: 'desktop',
  trackWelcomeAppPromoClick: () => {},
}

const mobileAppStoreCTAs = (device, trackWelcomeAppPromoClick) => (
  <a
    onClick={trackWelcomeAppPromoClick}
    data-testid="appPromoCTA"
    className={classnames(css.mobileAppLink, {
      [css.hideElement]: device === 'desktop' || device === 'tablet',
    })}
    href={config.routes.client.appsRedirect}
  >
    <Button width="100%">Download the app</Button>
  </a>
)

const desktopAppStoreCTAs = (device, trackWelcomeAppPromoClick) => (
  <div className={classnames({ [css.hideElement]: device === 'mobile' })}>
    <AppStoreLinks
      tracking={trackWelcomeAppPromoClick}
      appStoreId={config.apps.appStoreId}
      playStoreId={config.apps.playStoreId}
    />
  </div>
)

const AppPromo = ({ device, trackWelcomeAppPromoClick }) => (
  <div data-testid="appPromo">
    <div className={css.contentContainer}>
      <div className={css.content}>
        <h2 className={css.header}>Download the Gousto app</h2>
        <TickList listItems={benefits} listItemClassName={css.list} />
        <div>
          {mobileAppStoreCTAs(device, trackWelcomeAppPromoClick)}
          {desktopAppStoreCTAs(device, trackWelcomeAppPromoClick)}
        </div>
      </div>
    </div>
  </div>
)

AppPromo.propTypes = propTypes
AppPromo.defaultProps = defaultProps

export { AppPromo }
